var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.shareUserDialog,
        callback: function ($$v) {
          _vm.shareUserDialog = $$v
        },
        expression: "shareUserDialog",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.t("shardMemberSetting")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.shareUserDialog = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 pb-3",
                            attrs: { cols: "12", align: "left" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pb-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { align: "center" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pr-2",
                                        attrs: { cols: "10" },
                                      },
                                      [
                                        _c("v-autocomplete", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            items: _vm.allShareUserList,
                                            loading: _vm.searchLoading,
                                            "search-input": _vm.search,
                                            "append-icon": "",
                                            color: "white",
                                            dark: "",
                                            "hide-no-data": "",
                                            "hide-selected": "",
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            "item-text": "name",
                                            placeholder: _vm.t(
                                              "shareInputPlaceholder"
                                            ),
                                            "return-object": "",
                                          },
                                          on: {
                                            "update:searchInput": function (
                                              $event
                                            ) {
                                              _vm.search = $event
                                            },
                                            "update:search-input": function (
                                              $event
                                            ) {
                                              _vm.search = $event
                                            },
                                          },
                                          model: {
                                            value: _vm.shareUserInputValue,
                                            callback: function ($$v) {
                                              _vm.shareUserInputValue = $$v
                                            },
                                            expression: "shareUserInputValue",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "2" },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              width: "100%",
                                              height: "2rem",
                                              id: "blue_btn",
                                              elevation: "0",
                                            },
                                            on: { click: _vm.addShareUser },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.t("add2")) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "12", id: "user_list" },
                              },
                              _vm._l(_vm.shareUserList, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0 pl-1 pr-1",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-2 pt-1 pb-1",
                                        attrs: { cols: "12", id: "user_item" },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "center",
                                              justify: "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-3",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(item.mailAddress))]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ma-0 pa-0 mr-5",
                                                attrs: {
                                                  width: "auto",
                                                  height: "auto",
                                                  id: "back_clean_btn",
                                                  elevation: "0",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteShareUser(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    "max-height": "1.25rem",
                                                    "max-width": "1.25rem",
                                                    src: require("@/assets/images/close.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 mt-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      align: "center",
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-2",
                                        attrs: {
                                          width: "8rem",
                                          height: "auto",
                                          id: "grey_btn",
                                          elevation: "0",
                                        },
                                        on: { click: _vm.cancelEdit },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.t("back")) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-2 ml-2",
                                        attrs: {
                                          width: "8rem",
                                          height: "auto",
                                          loading: _vm.loading,
                                          id: "blue_btn",
                                          elevation: "0",
                                        },
                                        on: {
                                          click: _vm.requestUpdateStoreGroup,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.t("groupCreate")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }